import { useEffect } from 'react';
import AppProvider from 'contexts/AppContext';
import { useRouter } from 'next/router';
import MainLayout from '../components/layouts/MainLayout'
import smoothscroll from 'smoothscroll-polyfill';
import TagManager from 'react-gtm-module'
import '../styles/Globals.scss';

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  useEffect(()=> {
    smoothscroll.polyfill();
    TagManager.initialize({gtmId: 'GTM-5X8M5K8'})
  }, [])

  useEffect(()=>{
      TagManager.dataLayer({dataLayer:{
        event: 'pageview',
        page: {
          path: router.pathname,
        }
      }})

      if (
          window?.analytics?.page
          && process.env.NODE_ENV !== 'development'
      ){
        window.analytics.page({
          path: router.pathname,
          url: window.location.href,
        })
      }
  }, [router.pathname])

  return (
        <AppProvider>
          <MainLayout nav={Component.Nav} footer={Component.Footer} bodyScripts={Component.BodyScripts} authenticateClientSide={Component.authenticateClientSide || false}>
              <Component {...pageProps} />
          </MainLayout>
        </AppProvider>
    )
}

export default MyApp
